import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureAttributionParams } from '@/lib/promoAttribution';

export const AttributionListener = () => {
  const location = useLocation();

  useEffect(() => {
    captureAttributionParams(location.search);
  }, [location.search]);

  return null;
};
